// @flow
export const dataKey: 'accounting' = 'accounting';
